export const defaultUrl = () => `https://${process.env.REACT_APP_HOST_DOMAIN}`;
export const getCanonical = pathname => defaultUrl() + pathname.replace(/\/$/g, '');
